import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {ServerService} from "../../../services/server.service";
import {DxDataGridComponent, DxFileUploaderComponent} from "devextreme-angular";
import {DxService} from "../../../services/dx.service";
import {DialogService} from "../dialog/dialog.service";
import {GuiService} from "../../../services/gui.service";
import {ActivatedRoute} from "@angular/router";
import {ProdottoVariante} from "../../../models/ProdottoVariante";
import {environment} from "../../../../environments/environment";
import {PopupGenericComponent} from "../../dialogs/popup-generic/popup-generic.component";
import {FormGroupDirective} from "@angular/forms";
import {ModalUploadFileComponent} from "../modal-upload-file/modal-upload-file.component";

@Component({
   selector: 'app-tab-immagini',
   templateUrl: './tab-immagini.component.html',
   styleUrls: ['./tab-immagini.component.scss']
})
export class TabImmaginiComponent implements OnInit, AfterViewInit {
   @ViewChild('gridImage') gridImage!:DxDataGridComponent
   @ViewChild("fileUploadImage") fileUploadImage!:DxFileUploaderComponent;
   @ViewChild("dialogImages") dialogImages!:PopupGenericComponent;
   @ViewChild("appModalUploadComponent") appModalUploadComponent!:ModalUploadFileComponent;
   @ViewChild("frmFileUploadImage") frmFileUploadImage!:FormGroupDirective;

   private _pvariant;

   @Input() prodottoId;
   @Input() pVariantId;
   @Input()
   set pVariant(value: ProdottoVariante[]) {
      this._pvariant = value;
   }
   get pVariant(): ProdottoVariante[] {
      return this._pvariant;
   }

   @Input() tabs;
   @Input() isVariante;
   public vendorSlug;
   public popupImmaginiVisible: boolean = false;
   images: any[] = [];

   constructor(private serverSrv:ServerService,
               private dxSrv:DxService,
               private dialog:DialogService,
               private route:ActivatedRoute,
               private guiSrv:GuiService) {
      this.onReorder = this.onReorder.bind(this);
      // this.vendorSlug = this.route.parent?.parent?.parent?.snapshot.paramMap.get('esercizio_slug')
      this.route.pathFromRoot[3].params.subscribe(res => {
         this.vendorSlug = res.esercizio_slug
      })
   }

   ngOnInit(): void {}

   ngAfterViewInit(): void {
      if (this.pVariantId) this.initImageGrid()
         this.gridImage.onCellPrepared.subscribe(e => {
         if(e.rowType == "data" && e.column.dataField == "image"){
            let value = e.value
            if(value){
               let i = value.lastIndexOf("/")
               let v = value.substring(i+1, value.length)
               $(e.cellElement).html(`<a href="${value}" target="_blank">${v}</a>` )
            }
         }
      })
   }

   public refreshGridLayout() {
   this.dxSrv.fixGridLayout(this.gridImage);
}

   get imagesUrl(){
      return this.vendorSlug ?
         `/api/esercizi/${this.vendorSlug}/prodotti/${this.prodottoId}/varianti/${this.pVariantId}/images` :
         `/api/prodotti/${this.prodottoId}/varianti/${this.pVariantId}/images`
   }

   initImageGrid(){

      this.dxSrv.initGrid(this.gridImage, {
         showAdd: true,
         btnAddText: "Carica immagini",
         onClickNew: () => {
            this.popupImmaginiVisible = true
         }
      }).then(() => {
         setTimeout(() => {
            this.refreshGridLayout();
         }, 50);
      })

      // let url = this.vendorSlug ?
      //    `/api/esercizi/${this.vendorSlug}/prodotti/${this.prodottoId}/varianti/${this.pVariantId}/images` :
      //    `/api/prodotti/${this.prodottoId}/varianti/${this.pVariantId}/images`

      this.dxSrv.gridCreateDataSource(this.imagesUrl, this.gridImage,
         {
            update:(key: any, values: any)=>{
               this.serverSrv.put(this.imagesUrl + '/' + key, values).then(res => {
                  this.gridImage.instance.refresh()
                  this.dialog.showToastSuccess({msg:"Immagine modificata con successo."})
               }).catch(err => {
                  console.error(err)
               })
            }
         })

   }

   onReorder(e){
      let url = this.vendorSlug ?
         `/api/esercizi/${this.vendorSlug}/prodotti/${this.prodottoId}/varianti/${this.pVariantId}/images/${e.itemData.id}/setindex` :
         `/api/prodotti/${this.prodottoId}/varianti/${this.pVariantId}/images/${e.itemData.id}/setindex`
      let data = {
         'fromIndex':e.fromIndex + 1,
         'toIndex':e.toIndex + 1
      }
      this.serverSrv.put(url, data).then(res => {
         this.gridImage.instance.refresh()
      }).catch(err => {
         console.error(err)
      })
   }

   clickUploadImage(){
      let images = this.appModalUploadComponent.images
      if(images.length == 0) {
         console.warn("nessun file")
         return
      }

      this.guiSrv.showLoading()
      let files:any[] = []

      for (let i = 0; i < images.length; i++) {
         files.push({name:"file", file: images[i].file})
      }

      console.log(files)
      this.serverSrv.uploadFile(this.imagesUrl, files)
         .then(() => {
            this.guiSrv.hideLoading()
            this.fileUploadImage.instance.reset()
            this.dialog.showSuccess({msg:"File caricato con successo"});
            this.gridImage.instance.refresh()

         })
         .catch(err => {
            this.guiSrv.hideLoading()
            this.gridImage.instance.refresh()
            // this.dialog.showError({err:err});
            this.dialog.showToastError({title:"Errore Caricamento", err:err})
            console.error(err)
         })
         .finally(()=>{
            this.dialogImages.visible = false
            this.gridImage.instance.refresh()
         })
   }

   clickEliminaImmagine(id) {
      let url = this.vendorSlug ?
         `/api/esercizi/${this.vendorSlug}/prodotti/${this.prodottoId}/varianti/${this.pVariantId}/images/${id}` :
         `/api/prodotti/${this.prodottoId}/varianti/${this.pVariantId}/images/${id}`

      this.dialog.showConfirm({title:"Elimina immagine", msg:"Vuoi davvero eliminare l'immagine?"}).then(()=>{
         this.serverSrv.delete(url).then(res => {
            this.gridImage.instance.refresh()
            this.dialog.showSuccess({msg:"Immagine eliminata"})
         }).catch(err => {
            console.error(err)
            this.dialog.showError({title:"Attenzione!", err:err})
         })
      }).catch(err => {})

   }

   selectPVariant(value: any) {
      this.pVariantId = value
      this.initImageGrid()
   }

   clickChangeTab() {
      this.tabs.selectedIndex = 1
   }

   clickApriPdf() {
      window.open(environment.urlServer_nows + '/static/pdf/guida_scatti.pdf')
   }
}
